import $ from 'jquery';

import application from 'application/application';

import 'air-datepicker/dist/js/datepicker';

const LABELS_DEFINITIONS = {
	days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
	daysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
	daysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	months: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho', 'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
	monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
	today: 'Hoje',
	clear: 'Limpar'
};

$.fn.datepicker.language['pt-BR'] = {
	...LABELS_DEFINITIONS,
	dateFormat: 'dd/mm/yyyy',
	timeFormat: 'hh:ii aa',
	firstDay: 0
};

application

	.directive('inlineDatepicker', ['$timeout', ($timeout) => {

		return {
			scope: {},
			link: (scope, element, attrs) => {

				let datepicker;
				let selectCount = 0;
				let indexedHighlitedDays = {};
				let options = scope.$parent[attrs.inlineDatepicker];
				const model = scope.$parent[attrs.ngModel];

				if (options === null || typeof options !== 'object')

					options = {};


				const { ArrowButton } = Components();

				const defaults = {
					language: 'pt-BR',
					toggleSelected: false,
					navTitles : {
						days: 'MM yyyy',
						months: 'yyyy',
						years: 'yyyy1 - yyyy2'
					},
					prevHtml: ArrowButton('back'),
					nextHtml: ArrowButton('forward'),
					onRenderCell: (date, type) => {
						return {
							html: renderCellByType(date, type, indexedHighlitedDays, datepicker)
						};
					},
					onSelect(formattedDate, rawDate, instance) {
						if (typeof options.onSelect === 'function' && selectCount > 1)

							options.onSelect(formattedDate, rawDate, instance);


						if (selectCount < 2)

							selectCount += 1;

					}
				};

				const mergedOptions = $.extend({},
					defaults,
					options,
					{
						startDate: model.raw,
						onSelect: defaults.onSelect,
						onRenderCell: defaults.onRenderCell
					}
				);

				const unwatchModel = scope.$parent.$watch(attrs.ngModel, () => datepicker.selectDate(model.raw), true);

				const unwatchOptions = scope.$parent.$watch(attrs.inlineDatepicker, () => {
					indexedHighlitedDays = createIndexOfHighlitedDays(options.highlitedDays);

					updateOptions({ model, options, defaults, datepicker });
				}, true);

				scope.$on('$destroy', () => {
					unwatchModel();
					unwatchOptions();
				});

				indexedHighlitedDays = createIndexOfHighlitedDays(options.highlitedDays);

				datepicker = $($(element).datepicker(mergedOptions)).data('datepicker');

				datepicker.date = mergedOptions.startDate;

				$timeout(() => datepicker.selectDate(mergedOptions.date));

			}
		};

	}]);

function Components() {
	const components = {
		DayCell: ({ day } = {}) => `<span aria-highlited-day="false">${day}</span>`,
		YearCell: ({ year } = {}) => `<span aria-highlited-day="false">${year}</span>`,
		MonthCell: ({ month, datepicker } = {}) => LABELS_DEFINITIONS[datepicker.opts.monthsField][month],
		ArrowButton() {
		// 	return `
		// 		<button type="button" class="btn btn-link">
		// 			<i class="material-icons" aria-hidden="true">arrow_${side}</i>
		// 		</button>
		// 	`;
		},
		HighlitedDayCell({ day } = {}) {
			return `
				<div class="highlited-day" aria-highlited-day="true">
					<div class="highlited-day__text">
						${day}
					</div>
					<div class="highlited-day__dot fadeIn">
						<span class="calendar-square"></span>
					</div>
				</div>
			`;
		}
	};

	Object.keys(components).forEach(componentName => Components[componentName] = components[componentName]);

	return components;
}

function renderCellByType(date, type, highlitedDays, datepicker) {
	const _date = new Date(date);
	const units = { day: _date.getDate(), month: _date.getMonth(), year: _date.getFullYear() };

	let CellComponent;
	const props = { date, ...units, datepicker };
	const componentName = `${firstCharToUpperCase(type)}Cell`;

	CellComponent = isHighlitedDay(date, highlitedDays) ? Components.HighlitedDayCell : Components[componentName];

	if (CellComponent) {
		return CellComponent(props);
	}
};

function updateOptions({ model, options, defaults, datepicker }) {
	const mergedOptions = $.extend({}, defaults, options,
		{
			startDate: model.raw,
			onSelect: defaults.onSelect,
			onRenderCell: defaults.onRenderCell
		}
	);

	return datepicker.update(mergedOptions);
}

function isHighlitedDay(date, highlitedDays) {
	const _date = new Date(date);

	return highlitedDays[`${_date.getDate()}/${_date.getMonth()}`];
};

function createIndexOfHighlitedDays(array = []) {
	return array.reduce((indexedHighlitedDays, date) => {
		const _date = new Date(date);

		indexedHighlitedDays[`${_date.getDate()}/${_date.getMonth()}`] = true;

		return indexedHighlitedDays;
	}, {});
}

function firstCharToUpperCase(str = '') {
	if (str) {
		return `${str[0].toUpperCase()}${str.slice(1, str.length)}`;
	}
};
